import React, { useState } from 'react';
import CustomInput from '../../common/CustomInput';
import StaffProfileDropdown from '../../common/StaffProfileDropdown';

const AddLanguageModal = ({ onClose, onAdd, languageOptions = [], proficiencyOptions = [] }) => {
  const [formData, setFormData] = useState({
    language: '',
    proficiency: '',
    customLanguage: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Get the selected language label
    const selectedLanguage = languageOptions.find(option => option.value === formData.language);
    const selectedProficiency = proficiencyOptions.find(option => option.value === formData.proficiency);
    
    const languageName = formData.language === 'other' ? formData.customLanguage : (selectedLanguage ? selectedLanguage.label : formData.language);
    const proficiencyLevel = selectedProficiency ? selectedProficiency.value : formData.proficiency;
    
    const languageData = {
      language: languageName,
      proficiency: proficiencyLevel
    };
    
    onAdd(languageData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-[20px] font-bold text-[#1A212F]">ADD LANGUAGE</h2>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-[#2283FF] text-white rounded-lg"
            >
              Save
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Language Selection */}
          <div>
            <StaffProfileDropdown
              label="LANGUAGE"
              value={formData.language}
              onChange={(value) => handleInputChange("language", value)}
              options={languageOptions}
              placeholder="Select language"
            />
            {formData.language === 'other' && (
              <CustomInput
                label="ADD LANGUAGE NAME"
                value={formData.customLanguage}
                onChange={(e) => handleInputChange("customLanguage", e.target.value)}
                placeholder="Add language name here"
              />
            )}
          </div>

          {/* Proficiency Level */}
          <div>
            <StaffProfileDropdown
              label="PROFICIENCY LEVEL"
              value={formData.proficiency}
              onChange={(value) => handleInputChange("proficiency", value)}
              options={proficiencyOptions}
              placeholder="Select proficiency level"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLanguageModal; 